FeedsApp.Views.SelectedFeedView = Backbone.View.extend({

    events: {
        "click .selectAll": 'selectAllGroupRadios',
        "click .saveButton": "updateAssociations"
    },

    initialize: function() {
        this.model = new FeedsApp.Models.SelectedFeed;
        var self = this;
        $.ajax({
            url: '/assets/js/feeds/organization-access/templates/selected-feed-view.html',
            success: function(extTemplate) {
                self.template = _.template(extTemplate);
            },
            cache:true
        });

        $('.selected-feed-container').append(this.$el);
    },

    render: function() {
        this.$el.html(this.template(this.model.toJSON()));
    },

    refresh: function() {
        this.model.clear();
        var self = this;

        this.model.fetch({
            success: function() {
                self.render();
            }
        });
    },

    selectAllGroupRadios: function(e) {
        var grouping = $(e.currentTarget).val();

        $('input:radio.' + grouping).each(function(){
            if (!$(this).prop('checked')) {
                $(this).prop('checked', true).addClass("changed");
            }
        });
    },

    updateAssociations: function() {
        // Clears the old list of associations
        var self = this;
        self.model.set({activeAssociations: []});

        // Send the new list of enabled associations to the backend
        var newActiveAssociations = [];
        $('input:radio').each(function() {
            if ($(this).prop('checked') && !$(this).hasClass('selectAll')) {
                if ($(this).hasClass('enableOrg')) {
                    newActiveAssociations.push({organization_id: $(this).attr('value'), feed_id: FeedsApp.Variables.SelectedFeed})
                }
            }
        });
        self.model.set({activeAssociations: newActiveAssociations});
        self.model.submit();
    }

});